var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"people"}},[_c('v-client-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }